import { Controller } from "@hotwired/stimulus"

// The Issues area toolbars' <details> menus: one open at a time, closed by a click outside them or Esc. Their
// checkboxes wait for the menu's Apply, and closing a menu drops its unapplied picks.
export default class extends Controller {
  static targets = ["menu"]

  // `toggle` doesn't bubble, so each <details> wires it itself.
  toggle(event) {
    const menu = event.target
    if (menu.open) {
      this.menuTargets.forEach(other => { if (other !== menu) other.open = false })
    } else {
      // Otherwise the sub-accounts toggle's autosubmit, or another menu's Apply, would carry these picks.
      menu.querySelectorAll("input[type=checkbox]").forEach(box => { box.checked = box.defaultChecked })
    }
  }

  closeOutside(event) {
    if (!this.menuTargets.some(menu => menu.contains(event.target))) this.closeAll()
  }

  closeAll() {
    this.menuTargets.forEach(menu => { menu.open = false })
  }
}
